<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-clipboard-list</v-icon>
      <span class="ml-2 title">Editar encuesta</span>
    </v-card-title>
    <v-card-text>
      <v-form>
        <v-text-field
          v-model="value.descripcion"
          label="Descripción"
          :error-messages="errDescripcion"
        ></v-text-field>
        <v-text-field
          v-model="value.fecha_inicio"
          label="Fecha de inicio"
          type="datetime-local"
          :error-messages="errFechaInicio"
        ></v-text-field>
        <v-text-field
          v-model="value.fecha_fin"
          label="Fecha de fin"
          type="datetime-local"
          :error-messages="errFechaFin"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
      <v-spacer />
      <v-btn
        color="primary"
        :loading="loading"
        @click="updateEncuesta()"
      >
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import fechas from '../mixins/fechas'
export default {
  mixins: [fechas],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          id: null,
          descripcion: '',
          fecha_inicio: '',
          fecha_fin: ''
        }
      }
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    errDescripcion () {
      const errs = []
      if (!this.$v.value.descripcion.$dirty) return errs
      !this.$v.value.descripcion.required && errs.push('La descripción es requerida')
      return errs
    },
    errFechaInicio () {
      const errs = []
      if (!this.$v.value.fecha_inicio.$dirty) return errs
      !this.$v.value.fecha_inicio.required && errs.push('La fecha de inicio es requerida')
      return errs
    },
    errFechaFin () {
      const errs = []
      if (!this.$v.value.fecha_fin.$dirty) return errs
      !this.$v.value.fecha_fin.required && errs.push('La fecha de fin es requerida')
      return errs
    }
  },
  methods: {
    async updateEncuesta () {
      this.$v.value.$touch()
      if (!this.$v.value.$invalid &&
        this.validateFechas(this.value.fecha_inicio, this.value.fecha_fin)) {
        try {
          this.loading = true
          const data = {
            descripcion: this.value.descripcion,
            fecha_inicio: this.value.fecha_inicio,
            fecha_fin: this.value.fecha_fin
          }
          await this.$http.encuestas.put(`/${this.value.id}`, data)
          this.loading = false
          this.$emit('saved')
        } catch (error) {
          window.alert('😓 Ha ocurrido un error')
        }
      }
    }
  },
  validations: {
    value: {
      descripcion: { required },
      fecha_inicio: { required },
      fecha_fin: { required }
    }
  }
}
</script>
